import PropTypes from 'prop-types';
import React from 'react';
import { get } from 'lodash';
import classNames from 'classnames';
import { Avatar } from '@unite-us/ui';
import { AddressText, findPrimaryOrFirst, HoursOfOperationWeek, PhoneNumberDisplay, WebsiteUrl } from "../../moveToUUUtils";
var ServiceProviderListItem = function ServiceProviderListItem(_ref) {
  var provider = _ref.provider,
    isSelected = _ref.isSelected;
  var itemClass = function itemClass() {
    return classNames({
      'service-provider-list-item': true,
      selected: isSelected
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: itemClass()
  }, /*#__PURE__*/React.createElement("div", {
    className: "service-provider-list-item__avatar"
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: get(provider, 'logo_url'),
    size: "sm",
    alt: "".concat(provider.name, " avatar"),
    fallbackIcon: "IconElectronsArrow"
  })), /*#__PURE__*/React.createElement("div", {
    className: "service-provider-list-item__body"
  }, /*#__PURE__*/React.createElement("h3", null, provider.name), /*#__PURE__*/React.createElement(AddressText, {
    address: get(provider, 'addresses[0]')
  }), /*#__PURE__*/React.createElement(PhoneNumberDisplay, {
    item: findPrimaryOrFirst(get(provider, 'phone_numbers', [])),
    hidePrimaryDisplay: true,
    shortDisplay: true,
    noLink: true
  }), /*#__PURE__*/React.createElement(WebsiteUrl, {
    provider: provider,
    noLink: true
  }), /*#__PURE__*/React.createElement(HoursOfOperationWeek, {
    hours: provider.hours_of_operation
  })));
};
ServiceProviderListItem.propTypes = {
  provider: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  isSelected: PropTypes.bool
};
ServiceProviderListItem.defaultProps = {
  isSelected: false
};
export default ServiceProviderListItem;